import { render, staticRenderFns } from "./slide.vue?vue&type=template&id=cbaaac66&scoped=true&"
import script from "./slide.vue?vue&type=script&lang=js&"
export * from "./slide.vue?vue&type=script&lang=js&"
import style0 from "./slide.vue?vue&type=style&index=0&id=cbaaac66&prod&lang=scss&"
import style1 from "./slide.vue?vue&type=style&index=1&id=cbaaac66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbaaac66",
  null
  
)

export default component.exports